var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.016,
    height: 130,
    viewBox: "0 0 168.016 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 168.016,
    height: 130,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Btn_Watch",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-0.001 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M149.789,10a8.232,8.232,0,0,1,8.223,8.223v73.42a8.232,8.232,0,0,1-8.223,8.223H18.226A8.232,8.232,0,0,1,10,91.646V18.227A8.232,8.232,0,0,1,18.226,10Zm0-10H18.226A18.226,18.226,0,0,0,0,18.227v73.42a18.226,18.226,0,0,0,18.226,18.227H149.789a18.227,18.227,0,0,0,18.227-18.227V18.227A18.226,18.226,0,0,0,149.789,0",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M144.451,175.923H57.938a6.336,6.336,0,1,0,0,12.672h86.513a6.336,6.336,0,1,0,0-12.672",
    transform: "translate(-17.187 -58.595)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M91.221,87.434A5,5,0,0,1,87.684,78.9L121.7,44.881a5,5,0,0,1,7.074,7.074L94.758,85.969a4.985,4.985,0,0,1-3.537,1.465",
    transform: "translate(-28.717 -14.461)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M124.015,96.184a5,5,0,0,1-3.537-8.539l13.083-13.082a5,5,0,0,1,7.073,7.073L127.552,94.718a4.985,4.985,0,0,1-3.537,1.465",
    transform: "translate(-39.64 -24.347)",
    fill: "#1152e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchDefault);
export default __webpack_public_path__ + "static/media/watch-default.cf67fec7235b07ef7497b0982c22d968.svg";
export { ForwardRef as ReactComponent };